var Router = require("react-router");
var CurrentUser = require("lib/account/CurrentUser");
var ResponseModal = require("components/writing/responses/ResponseModal");

class ResponsePage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var responseID = this.props.match.params.id;
		var responseModal = (
			<ResponseModal ref="responseModal" key={ responseID }
				responseID={ responseID } user={ CurrentUser.get() }
				onHide={ this.onModalHide } />
		);

		return (
			<div className="container" id="responsePage">
				{ responseModal }
			</div>
		)
	}

	onModalHide() {
		$wr.redirect('/');
	}

	componentDidMount() {
		this.refs.responseModal.show();
	}
};

ResponsePage.propTypes = PageStrictPropTypes({
});

module.exports = ResponsePage;



// WEBPACK FOOTER //
// ./modules/components/writing/responses/ResponsePage.js